/*
Motivation:
 - Need separate all strings in preparation for translation implementation
 - NOTE: This is partial for now but eventually migrate all strings in the future.
 */

export const UNDEFINED: string = 'undefined';
export const WAIT_INDICATOR: string = "....";